<template>
  <div class="task-detail-page-header" data-testid="setup-task-detail__header">
    <div class="task-detail-page-header__nav d-flex align-center">
      <button
        type="button"
        class="task-detail-page-header__back-btn"
        aria-label="Back to Task Library"
        data-testid="setup-task-detail__back-btn"
        @click="$emit('back')"
      >
        <img class="" src="/img/icons/fbc-icons/BackArrow.svg" alt="Back" />
      </button>

      <nav
        class="task-detail-page-header__breadcrumb d-flex align-center"
        aria-label="Breadcrumb"
        data-testid="setup-task-detail__breadcrumb"
      >
        <span
          class="task-detail-page-header__breadcrumb-link"
          data-testid="setup-task-detail__breadcrumb-setup"
        >
          Setup
        </span>
        <v-icon size="12" class="task-detail-page-header__breadcrumb-sep">
          mdi-chevron-right
        </v-icon>
        <button
          type="button"
          class="task-detail-page-header__breadcrumb-link task-detail-page-header__breadcrumb-link--clickable"
          data-testid="setup-task-detail__breadcrumb-task-library"
          @click="$emit('back')"
        >
          Task Library
        </button>
      </nav>
    </div>

    <div class="task-detail-page-header__main d-flex justify-space-between align-center">
      <div class="task-detail-page-header__info d-flex align-center">
        <span
          class="task-detail-page-header__ref-chip"
          data-testid="setup-task-detail__ref-chip"
        >
          {{ refLabel }}
        </span>
        <h5
          class="task-detail-page-header__title ma-0"
          data-testid="setup-task-detail__title"
        >
          {{ template.description || '—' }}
        </h5>
      </div>

      <v-btn
        class="task-detail-page-header__edit-btn text-none white--text"
        :disabled="loading"
        height="32"
        data-testid="setup-task-detail__edit-template-btn"
        @click="$emit('edit')"
      >
        <v-icon left size="16">mdi-pencil-outline</v-icon>
        Edit Template
      </v-btn>
    </div>
  </div>
</template>

<script>
import './TaskDetailPageHeader.scss';

export default {
  name: 'TaskDetailPageHeader',

  props: {
    template: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    refLabel() {
      return this.template.ref || this.template.reference || '—';
    },
  },
};
</script>
